// extracted by mini-css-extract-plugin
export default {"Question":"ParentalGate_Question__py0-C","Input":"ParentalGate_Input__u5gWy","Lines":"ParentalGate_Lines__cbIDQ","Submit":"ParentalGate_Submit__5A9Z3"};